import React, { useState } from "react";
import toast from "react-hot-toast";

type ModalApontamentoACVProps = {
  onSubmit: (data: { autoClave: string; carro: string; ciclo: string; matricula: string; }) => void;
  onCancel?: () => void;
};

export const ModalApontamentoACV = ({ onSubmit, onCancel }: ModalApontamentoACVProps) => {
  const [autoClave, setAutoClave] = useState("");
  const [carro, setCarro] = useState("");
  const [ciclo, setCiclo] = useState("");
  const [matricula, setMatricula] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 🔹 Mapeamento entre AutoClave e seus carros
  const carrosPorAutoClave: Record<string, string[]> = {
    Chicago: ["Chicago - 1", "Chicago - 2", "Chicago - 3"],
    "Matriz Molde": ["Matriz - 1", "Matriz - 2"],
    Ferlex: ["Ferlex - 1", "Ferlex - 2", "Ferlex - 3"],
    Fhaizer: ["Fhaizer - 1", "Fhaizer - 2", "Fhaizer - 3"],
  };

  const resetForm = () => {
    setAutoClave("");
    setCarro("");
    setCiclo("");
    setMatricula("");
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (matricula.trim().length < 6) {
      toast.error("Informe a matrícula SAP (6 caracteres)");
      return;
    }

    if (!autoClave || !carro || !ciclo || !matricula) {
      alert("Preencha todos os campos antes de enviar.");
      return;
    }

    setIsSubmitting(true);

    try {
      onSubmit({ autoClave, carro, ciclo, matricula });
      resetForm();
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    resetForm();
    onCancel?.();
  };

  // 🔹 Lista de carros filtrados conforme o AutoClave escolhido
  const carrosFiltrados = carrosPorAutoClave[autoClave] || [];

  return (
    <form onSubmit={handleSubmit}>
      <div className="row g-3">
        <div className="col-12">
          <div className="card p-3 mb-3 shadow-sm rounded-3 bg-light">
            <h6 className="fw-bold text-secondary mb-3">Criação do Ciclo</h6>
            <div className="row g-3">

              {/* Auto-Clave */}
              <div className="col-md-6">
                <label className="form-label small fw-semibold text-muted">AutoClave</label>
                <select
                  className="form-select border-primary"
                  value={autoClave}
                  onChange={(e) => {
                    setAutoClave(e.target.value);
                    setCarro("");
                  }}
                  required
                >
                  <option value="">Escolha o Auto-Clave</option>
                  <option value="Chicago">Chicago</option>
                  <option value="Matriz Molde">Matriz Molde</option>
                  <option value="Ferlex">Ferlex</option>
                  <option value="Fhaizer">Fhaizer</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label small fw-semibold text-muted">Carro</label>
                <select
                  className="form-select border-primary"
                  value={carro}
                  onChange={(e) => setCarro(e.target.value)}
                  disabled={!autoClave} // bloqueia até escolher a autoclave
                  required
                >
                  <option value="">Escolha o carro</option>
                  {carrosFiltrados.map((carroNome) => (
                    <option key={carroNome} value={carroNome}>
                      {carroNome}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label small fw-semibold text-muted">Ciclo</label>
                <select
                  className="form-select border-primary"
                  value={ciclo}
                  onChange={(e) => setCiclo(e.target.value)}
                  required
                >
                  <option value="">Escolha o ciclo</option>
                  <option value="CICLO PCHT N3">CICLO PCHT N3</option>
                  <option value="CICLO PCHT IB33">CICLO PCHT IB33</option>
                  <option value="CICLO AL NV7 NIMR">CICLO AL NV7 NIMR</option>
                  <option value="CICLO KAROTEK PET">CICLO KAROTEK PET</option>
                  <option value="CICLO KAROTEK NORTHGLASS">CICLO KAROTEK NORTHGLASS</option>
                  <option value="CICLO PCHT N5 AGPB">CICLO PCHT N5 AGPB</option>
                  <option value="CICLO AL NV5 COM AÇO">CICLO AL NV5 COM AÇO</option>
                  <option value="CICLO NV8 PCHT AGPB">CICLO NV8 PCHT AGPB</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label small fw-semibold text-muted">
                  Matrícula
                </label>

                <input
                  type="text"
                  placeholder="Matrícula SAP"
                  className="form-control border-primary"
                  value={matricula}
                  minLength={6}
                  onChange={(e) => setMatricula(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end gap-2">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => handleCancel()}
          disabled={isSubmitting}
        >
          Cancelar
        </button>

        <button
          type="submit"
          className="btn btn-primary"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Enviando..." : "Enviar"}
        </button>
      </div>
    </form>
  );
};
